export default [
  {
    name: 'dashboard',
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'el-icon-s-home',
    disabled: false,
    translator: false,
    turkish: false
  },
  {
    name: 'candidates',
    path: '/candidates',
    title: 'Candidates',
    icon: 'el-icon-user',
    disabled: false,
    translator: false,
    turkish: false
  },
  {
    name: 'recruiters',
    path: '/recruiters',
    title: 'Recruiters',
    icon: 'el-icon-s-cooperation',
    disabled: false,
    translator: false,
    turkish: true
  },
  {
    name: 'registration-exceptions',
    path: '/registration-exceptions',
    title: 'Registration Exceptions',
    icon: 'el-icon-unlock',
    disabled: false,
    translator: false,
    turkish: false
  },
  {
    name: 'activity',
    path: '/activity',
    title: 'Activity',
    icon: 'el-icon-view',
    disabled: false,
    translator: false,
    turkish: false
  },
  {
    name: 'matchmaking',
    path: '/matchmaking',
    title: 'Matchmaking',
    icon: 'el-icon-guide',
    disabled: true,
    translator: false,
    turkish: false
  },
  {
    name: 'email-signature',
    path: '/email-signature',
    title: 'Email Signature',
    icon: 'el-icon-message',
    disabled: false,
    translator: false,
    turkish: false
  },
  {
    name: 'translate-dashboard',
    path: '/translate/dashboard',
    title: 'Dashboard Translate',
    icon: 'el-icon-chat-dot-square',
    disabled: true,
    translator: true,
    turkish: false
  },
  {
    name: 'notifications',
    path: '/notifications',
    title: 'Notifications',
    icon: 'el-icon-bell',
    disabled: false,
    translator: false,
    turkish: false
  },
  {
    name: 'advanced-report',
    path: '/advanced-report',
    title: 'Advanced Report',
    icon: 'el-icon-s-data',
    disabled: false,
    translator: false,
    turkish: false
  }
  // {
  //   name: 'comparison',
  //   path: '/comparison',
  //   title: 'Test Comparison',
  //   icon: 'el-icon-s-order',
  //   disabled: false
  // }
]
